export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5932.b6f22bb5.jpg";